{
  "id": 26,
  "location": "paris",
  "difficulty": "normal",
  "moves": 15,
  "kinds": 6,
  "goals": [
    { "type": "stain" },
    { "type": "collect", "kind": "cookie", "count": 26 }
  ],
  "stars": [3130, 4100],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . ~. ~. ~. ~. . .",
    ". . ~. ~. ~. ~. . .",
    ". . ~. ~. ~. ~. . .",
    ". . ~. ~. ~. ~. . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.675, "movesLeft": 3.4, "closeLosses": 0.145, "target": 0.67 }
}
